import type { LabelHTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';

/**
 * Label — Agent Builder's uppercase tracked label for form fields.
 *
 *   text-[11-12px] font-bold uppercase tracking-wider
 *   gray-400 (dark) / gray-600 (light)
 */
interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
    isDarkMode?: boolean;
    required?: boolean;
    children: ReactNode;
}

export default function Label({ isDarkMode = false, required, children, className, ...rest }: LabelProps) {
    return (
        <label
            className={cn(
                'block text-[11px] font-bold uppercase tracking-wider mb-1.5',
                isDarkMode ? 'text-gray-400' : 'text-gray-600',
                className,
            )}
            {...rest}
        >
            {children}
            {required && <span className="text-red-500 ml-1">*</span>}
        </label>
    );
}
